"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.process_tech_provision_inputs = void 0;
exports.process_tech_provision_inputs = [
    {
        component: 'field',
        label: 'Workcell Number',
        name: 'workcellNumber',
        description: 'Workcell Number should be three digits (ex: 101) and unique under the same Process and FC',
        regex: '^[0-9]{3}$',
        defaultValue: '',
    },
    {
        component: 'provision-input-group',
        label: 'Application URL',
        name: 'ApplicationUrl',
        description: 'Example: http://10.232.18.10:3000/?zoneId=SR-103&displayId=SR-103-tv1&node=SLC2&position=front',
        regex: '.*',
        defaultValue: '',
    },
    {
        component: 'provision-input-group-optional',
        label: 'Display Resolution',
        name: 'DisplayResolution',
        description: 'Display resolution for application',
        regex: '^[a-zA-Z0-9]*',
        defaultValue: '',
    },
    {
        component: 'provision-input-group-optional',
        label: 'Display Rotation',
        name: 'DisplayRotation',
        description: 'Display rotation for application',
        regex: '^[a-zA-Z0-9]*',
        defaultValue: '',
    },
    {
        component: 'provision-input-group-optional',
        label: 'Display Reflection',
        name: 'DisplayReflection',
        description: 'Display reflection for application',
        regex: '^[a-zA-Z0-9]*',
        defaultValue: '',
    },
];
